<template>
    <TabView class="custom-tabview">
        <TabPanel class="custom-tabpanel" header="Status">
            <div class="card p-3 border-radius-xl" data-animation="FadeIn">
                <h5 class="font-weight-bolder mb-0">Status da Obra</h5>
                <p class="mb-0 text-sm">Veja aqui o andamento da obra</p>
                <p v-if="lastUpdate" class="mb-0 text-sm mb-4">Atualizado em: {{ formatDate(lastUpdate) }}</p>
                <div class="mt-4">
                    <div class="row">
                        <div class="mx-auto col-md-12">
                            <div id="accordion" class="accordion">
                                <template v-if="loading">
                                    <div class="d-flex justify-content-center mt-2">
                                        <p><i class="fas fa-spinner fa-pulse"></i> Aguarde</p>
                                    </div>
                                </template>
                                <template v-else>
                                    <template v-if="towers">
                                        <accordion-item v-for="(tower, index) in towers" :key="index"
                                            :accordion-id="`headingBuilding${index}`" :collapse-id="index">
                                            <template #question>{{ tower.data.Name }}</template>
                                            <template #answer>
                                                <progress-card v-for="(progress, title) in towerProgressData(tower)"
                                                    :key="title" :progress="progress" :title="title" />
                                            </template>
                                        </accordion-item>
                                    </template>
                                    <template v-else-if="building">
                                        <accordion-item accordion-id="headingBuilding1" collapse-id="collapseBuilding1"
                                            active=true>
                                            <template #question>{{ building.Name }}</template>
                                            <template #answer>
                                                <progress-card v-for="(progress, title) in buildingProgressData"
                                                    :key="title" :progress="progress" :title="title" />
                                            </template>
                                        </accordion-item>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TabPanel>
        <TabPanel class="custom-tabpanel" header="Imagens">
            <images-card :images="images" />
        </TabPanel>
    </TabView>
</template>

<script setup>
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import ProgressCard from './components/ProgressCard.vue';
import ImagesCard from './components/ImagesCard.vue';
import AccordionItem from "./components/AccordionItem.vue";
import axios from 'axios';
import { useStore } from "vuex";
import { computed, onMounted, ref } from "vue";
import moment from 'moment';

const store = useStore();
const contractData = computed(() => store.getters.getCurrentContract);

const loading = ref(false);
const towers = ref(null);
const building = ref(null);
const images = ref([]);
const lastUpdate = ref();

const progressTitles = [
    { key: 'AndamentoGeral__c', title: 'Andamento Geral' },
    { key: 'Contencao__c', title: 'Contenção' },
    { key: 'Escavacao__c', title: 'Escavação' },
    { key: 'Fundacao__c', title: 'Fundação' },
    { key: 'Estrutura__c', title: 'Estrutura' },
    { key: 'Alvenaria__c', title: 'Alvenaria' },
    { key: 'Instalacao__c', title: 'Instalação' },
    { key: 'Acabamento__c', title: 'Acabamento' }
];

const towerProgressData = (tower) =>
    progressTitles.reduce((acc, { key, title }) => {
        acc[title] = tower.data[key];
        return acc;
    }, {});

const buildingProgressData = computed(() =>
    progressTitles.reduce((acc, { key, title }) => {
        acc[title] = building.value[key];
        return acc;
    }, {})
);

const formatDate = (dataString) => {
    const data = moment(dataString, 'YYYY-MM-DD HH:mm:ss');
    return data.format('DD/MM/YYYY');
};

onMounted(async () => {
    await fetchData();
});

async function fetchData() {
    try {
        loading.value = true;
        const response = await axios.get(`/enterprises/${contractData.value.id_empreendimento}`);
        const data = response.data.data;

        if (data.EmpreendimentoFaseado__c) {
            towers.value = response.data.towers;
        } else {
            building.value = data;
            lastUpdate.value = data.DataReferencia__c
        }
        if (data.image1 && data.image1.versionData) {
            images.value['1'] = 'data:image/jpeg;base64,' + data.image1.versionData;
        }
        if (data.image2 && data.image2.versionData) {
            images.value['2'] = 'data:image/jpeg;base64,' + data.image2.versionData;
        }
        images.value['lastUpdate'] = response.data.data.DataReferenciaFotoObra__c;
    } catch (error) {
        console.error(error);
    } finally {
        loading.value = false;
    }
}
</script>

<style>
.custom-tabview .p-tabview-nav {
    border-radius: 13px;
    flex: 1 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    text-align: center;
}

.custom-tabview .p-tabview-panels {
    border-radius: 13px;
}

.custom-tabpanel {
    border-radius: 13px;
}

.p-tabview .p-tabview-panels {
    padding: 0;
}

.p-tabview-ink-bar {
    display: none !important;
}

.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
    margin: 10px;
    border-radius: 30px;
    padding: 8px 20px;
    height: 40px;
    background-color: #866c9183 !important;
    border-top-right-radius: 30px !important;
    border-top-left-radius: 30px !important;
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link {
    border-width: 0 !important;
}

.loading-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.loading-spinner .pi {
    font-size: 2em;
    color: #866c91;
}
</style>